export default __webpack_public_path__ + "static/media/thumbnail_image_2.fc96d246.png";